/*
  Elite Fanstore - Promo mystère (assets/promo-mystere.js), rendu par sections/promo-mystere.liquid.
  « Deuxième chance » de la pop-up roue Klaviyo (formulaire data-form) : la section reste cachée tant que le visiteur
  n'a pas fermé cette pop-up sans s'inscrire, puis son bouton la rouvre (_klOnsite openForm).
  Fermeture et inscription sont lues dans les événements « klaviyoForms » de la page, gardées dans le navigateur
  (localStorage), et aussi dans la mémoire de Klaviyo (klaviyoOnsite) pour une fermeture faite sur une autre page.
  Dans l'éditeur Shopify, la section est toujours visible et rien n'est gardé.
*/
(() => {
  if (customElements.get('promo-mystere')) return;
  const KEY = 'elite-roue-klaviyo';
  const DONE = ['submit', 'stepSubmit', 'spinToWin'];
  const read = key => { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) { return null; } };
  class PromoMystere extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.messages = Object.assign({"unavailable":"L’offre ne s’ouvre pas pour le moment. Réessaie dans un instant."}, JSON.parse(this.dataset.i18n || '{}'));
      this.formId = this.dataset.form || '';
      if (!/^[A-Za-z0-9]{4,12}$/.test(this.formId)) return;
      this.design = !!(window.Shopify && window.Shopify.designMode);
      this.status = this.querySelector('[data-status]');
      this.button = this.querySelector('[data-open]');
      this.button.disabled = false;
      this.button.addEventListener('click', () => this.open());
      window.addEventListener('klaviyoForms', e => this.onForm(e.detail || {}));
      if (!this.design && this.state() === 'closed') this.reveal(false);
    }
    // 'done' (inscrit), 'closed' (fermée sans inscription) ou null (pas encore vue)
    state() {
      const own = read(KEY);
      if (own && own.form === this.formId && own.state === 'done') return 'done';
      const kl = read('klaviyoOnsite')?.viewedForms?.modal?.disabledForms?.[this.formId];
      if (kl && Array.isArray(kl.successActionTypes) && kl.successActionTypes.length) return 'done';
      if ((own && own.form === this.formId && own.state === 'closed') || kl) return 'closed';
      return null;
    }
    save(state) {
      if (this.design) return;
      try { localStorage.setItem(KEY, JSON.stringify({ form: this.formId, state, t: Date.now() })); } catch (_) {}
    }
    reveal(animate) {
      if (!this.hidden || this.state() !== 'closed') return;
      if (animate) this.classList.add('is-arriving');
      this.hidden = false;
      // Déjà connu de Klaviyo (inscrit ailleurs, venu d'un e-mail) : la pop-up ne lui est plus destinée.
      // isIdentified() reste sans réponse pour un inconnu : vérifié en arrière-plan, sans retarder l'affichage.
      const kl = window.klaviyo;
      if (kl && typeof kl.isIdentified === 'function') Promise.resolve(kl.isIdentified()).then(known => { if (known && !this.design) this.hidden = true; }, () => {});
    }
    onForm(detail) {
      if (detail.formId !== this.formId) return;
      if (detail.type === 'open') {
        clearTimeout(this.timer);
        this.status.textContent = '';
      } else if (DONE.includes(detail.type)) {
        this.save('done');
        if (!this.design) this.hidden = true;
      } else if (detail.type === 'close' && this.state() !== 'done') {
        this.save('closed');
        if (!this.design) this.reveal(true);
      }
    }
    open() {
      this.status.textContent = '';
      this.classList.remove('is-opening');
      void this.offsetWidth;
      this.classList.add('is-opening');
      setTimeout(() => this.classList.remove('is-opening'), 700);
      (window._klOnsite = window._klOnsite || []).push(['openForm', this.formId]);
      // Klaviyo bloqué ou formulaire retiré : aucun événement « open » ne revient.
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { this.status.textContent = this.messages.unavailable; }, 4000);
    }
  }
  customElements.define('promo-mystere', PromoMystere);
})();
